import React, { useEffect, useState } from 'react'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse, IconButton } from '@mui/material'
import { TableCellStyled, TableRowStyled, TableStyled } from 'components'
import { If, Then } from 'react-if'
import { Item } from 'services/NGT/EffectiveConsolidation'
import { COLORS } from 'utils'
import { FormatEffectiveQuantityNumbers as FormatNumber} from '../../utils/FormatEffectiveQuantityNumbers'

interface ICollapsibleTable {
  row: Item
  isGeneratePDF: boolean
}

export const CollapsibleTable: React.FC<ICollapsibleTable> = ({
  row,
  isGeneratePDF
}) => {
  const [open, setOpen] = useState(isGeneratePDF)

  useEffect(() => {
    if (isGeneratePDF) setOpen(true)
  }, [isGeneratePDF])

  return (
    <>
      <TableRowStyled>
        <TableCellStyled>
          {row?.unidadeGestoraInfo.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCellStyled>
        <TableCellStyled align="left">
          {row?.nmGrupoConsolidacao}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row?.informaoAnoMeses[12]?.info?.qtdTotalEfetivo}
        </TableCellStyled>

        {row?.informaoAnoMeses.map((info, index) => (
          <If key={info.mes} condition={index !== 12}>
            <Then>
              <TableCellStyled align="center">
                {info.info.qtdTotalEfetivo ?? 0}
              </TableCellStyled>
            </Then>
          </If>
        ))}

        <TableCellStyled align="center">{row?.variacao + '%'}</TableCellStyled>
      </TableRowStyled>

      {/*  INICIO TABLE COLLAPSED */}
      <TableRowStyled style={{ display: !open && 'none' }}>
        <TableCellStyled style={{ padding: 0 }} colSpan={16}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableStyled>
              <TableRowStyled backgroundColor={COLORS.tableColor}>
                <TableCellStyled colSpan={2} />
                <TableCellStyled align="center">Dez</TableCellStyled>
                <TableCellStyled align="center">Jan</TableCellStyled>
                <TableCellStyled align="center">Fev</TableCellStyled>
                <TableCellStyled align="center">Mar</TableCellStyled>
                <TableCellStyled align="center">Abr</TableCellStyled>
                <TableCellStyled align="center">Mai</TableCellStyled>
                <TableCellStyled align="center">Jun</TableCellStyled>
                <TableCellStyled align="center">Jul</TableCellStyled>
                <TableCellStyled align="center">Ago</TableCellStyled>
                <TableCellStyled align="center">Set</TableCellStyled>
                <TableCellStyled align="center">Out</TableCellStyled>
                <TableCellStyled align="center">Nov</TableCellStyled>
                <TableCellStyled align="center">Dez</TableCellStyled>
                <TableCellStyled align="center">Variação</TableCellStyled>
              </TableRowStyled>

              {row?.unidadeGestoraInfo.map((collapseRow, index) => (
                <TableRowStyled key={index}>
                  <TableCellStyled align="left" minwidth="200px" colSpan={2}>
                    {collapseRow?.nmUnidadeGestora}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {FormatNumber.formatarNumero(collapseRow.informaoAnoMeses[12].info.qtdTotalEfetivo)}
                  </TableCellStyled>

                  {collapseRow?.informaoAnoMeses.map((info, index2) => (
                    <If key={info.mes} condition={index2 !== 12}>
                      <Then>
                        <TableCellStyled align="center">
                          {FormatNumber.formatarNumero(info?.info.qtdTotalEfetivo) ?? 0}
                        </TableCellStyled>
                      </Then>
                    </If>
                  ))}

                  <TableCellStyled align="center">
                    {FormatNumber.formatarNumero(collapseRow?.variacao) + '%'}
                  </TableCellStyled>
                </TableRowStyled>
              ))}
            </TableStyled>
          </Collapse>
        </TableCellStyled>
      </TableRowStyled>
    </>
  )
}
